'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSize = exports.getSize = function getSize(size) {
  return size || '40px';
};

var getColor = exports.getColor = function getColor(color) {
  return color || '#333';
};